module.exports = __webpack_public_path__ + "static/media/pic_friend_new.ebc72357.jpg";